import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { LookInside } from './components/LookInside';
import { BonusesSection } from './components/BonusesSection';
import { NotAnEbook } from './components/NotAnEbook';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { MetaPixel } from './components/MetaPixel';
interface AppProps {
  showPurchaseToasts?: boolean;
}
export function App({
  showPurchaseToasts = true
}: AppProps) {
  return <div lang="en" className="w-full bg-slate-950 font-sans antialiased" data-id="element-0" data-mp="23ti67z10skhk">
      <Hero data-id="element-1" data-mp="3ijpc2xoqyt86" />
      <main data-id="element-2" data-mp="3ihuyk4ft23e4">
        <ProblemSection data-id="element-3" data-mp="3mljaezbgzl56" />
        <SystemSection data-id="element-4" data-mp="3mkrd9k285fcs" />
        <WhatsIncluded data-id="element-5" data-mp="3mk84asujy1aw" />
        <LookInside data-id="element-6" data-mp="3mjgannkimdn9" />
        <BonusesSection data-id="element-7" data-mp="3rc9dg5wfbbwp" />
        <NotAnEbook data-id="element-8" data-mp="3rbzmaezn6ypf" />
        <OfferSection data-id="element-9" data-mp="3rdkg22e4udm8" />
        <GuaranteeSection data-id="element-10" data-mp="3recerm310rgq" />
        <TestimonialsSection data-id="element-11" data-mp="5ygolyg4xb6" />
        <FaqSection data-id="element-12" data-mp="4wvhonpuufq" />
        <FinalCta data-id="element-13" data-mp="5ggje8nxyxz" />
      </main>
      <Footer data-id="element-14" data-mp="7stte3h7l4p" />
      {showPurchaseToasts && <PurchaseToast data-id="element-15" data-mp="2zlv8iz6e19x6" />}
      <MetaPixel data-id="element-16" data-mp="2zmo3z3zwcd00" />
    </div>;
}